exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".apply-policy-container #retention {\n  width: 200px; }\n\n.apply-policy-container form {\n  padding-top: 0; }\n\n.apply-policy-container .error-message-box-container {\n  padding-top: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/apply-policy/apply-policy.scss
// module id = JGB8
// module chunks = 0